import { ReactElement } from 'react';
import { AuthChannelType } from '@hotelplan/fdr.lib.ident.auth-config';
import { useAuthentication } from '@hotelplan/fdr.lib.ident.with-auth';
import { useDeviceType } from '@hotelplan/libs.context.device-type';
import { useToggleState } from '@hotelplan/libs.hooks-react';
import {
  FdrCo2Footprint as FdrCo2FootprintType,
  FdrRequestButton,
} from '@hotelplan/supergraph-api';
import { Container } from 'components/domain/container';
import {
  FdrCo2FootprintBodyDesktop,
  FdrCo2FootprintHeaderDesktop,
} from './fdr-co2-footprint-desktop';
import {
  FdrCo2FootprintBodyMobile,
  FdrCo2FootprintHeaderMobile,
} from './fdr-co2-footprint-mobile';
import { FdrCO2FootprintWrapper } from './fdr-co2-footprint.styles';

export function FdrCo2Footprint({
  requestButton,
  ...co2Props
}: FdrCo2FootprintType & { requestButton?: FdrRequestButton }): ReactElement {
  const { mobile } = useDeviceType();
  const { channelType } = useAuthentication();

  const [isCO2FootprintBodyOpen, openCO2FootprintBody, closeCO2FootprintBody] =
    useToggleState(false);

  const isB2B = channelType === AuthChannelType.B2B;

  if (mobile) {
    return (
      <FdrCO2FootprintWrapper isB2B={isB2B}>
        <FdrCo2FootprintHeaderMobile
          isOpened={isCO2FootprintBodyOpen}
          onOpen={openCO2FootprintBody}
          totalEmission={co2Props.totalEmission}
        />
        <FdrCo2FootprintBodyMobile
          {...co2Props}
          requestButton={requestButton}
          isOpened={isCO2FootprintBodyOpen}
          onClose={closeCO2FootprintBody}
        />
      </FdrCO2FootprintWrapper>
    );
  }

  return (
    <Container>
      <FdrCO2FootprintWrapper isB2B={isB2B}>
        <FdrCo2FootprintHeaderDesktop
          isOpened={isCO2FootprintBodyOpen}
          onOpen={openCO2FootprintBody}
          totalEmission={co2Props.totalEmission}
        />
        <FdrCo2FootprintBodyDesktop
          {...co2Props}
          requestButton={requestButton}
          isOpened={isCO2FootprintBodyOpen}
          onClose={closeCO2FootprintBody}
        />
      </FdrCO2FootprintWrapper>
    </Container>
  );
}
